export default __webpack_public_path__ + "static/media/cisius_3.3c970e9e.png";